import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CarouselEventNavigation } from 'src/domains/layouts/webview/components/eventNavigation/CarouselEventNavigation';
import { useAppStateContext } from 'src/appState/AppState';
import {
    BackButton,
    EventNavigation,
} from 'src/domains/layouts/webview/components/eventNavigation/CarouselSelection.style';
import {
    EventRouteType,
    RacecardMeetingsRouteType,
    RacecardRaceRouteType,
} from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { ModelsState } from 'src_common/common/websocket2/ModelsState';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { useCommon } from 'src/domains/common/Common';

const getId = (
    models: ModelsState,
    currentView: EventRouteType | RacecardMeetingsRouteType | RacecardRaceRouteType
): EventId | null => {
    if (currentView.name === 'event') {
        return models.id.getEventId(currentView.id);
    }
    // TODO: check the if is needed
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (currentView.name === 'racecard') {
        return models.id.getEventIdOption(currentView.selected);
    }
    return null;
};

interface AlternativeNavigationPropsType {
    currentView: EventRouteType | RacecardMeetingsRouteType | RacecardRaceRouteType;
}

export const AlternativeNavigation = observer('AlternativeEvent', (props: AlternativeNavigationPropsType) => {
    const common = useCommon();
    const { appSportsBookState } = useAppStateContext();
    const { alternativeEventState, models } = appSportsBookState;
    const starRouter = StarRouter.get(common);
    const id = getId(models, props.currentView);
    const { eventId } = alternativeEventState.get(id);

    if (eventId === null || id === null) {
        return null;
    }

    const actualEvent = id.getEventModel();

    const eventModel = eventId.getEventModel();

    if (eventModel === null) {
        return null;
    }

    const { sport } = eventModel;

    if (sport === 'greyhoundracing' || sport === 'horseracing' || props.currentView.name === 'racecard') {
        return null;
    }

    const handleRedirectToCompetitionPage = (): void => {
        starRouter.redirectToPreviousPage(() => {
            if (actualEvent !== null) {
                starRouter.redirectToCompetitionPage(actualEvent.competition, actualEvent.sport);
            }
        });
    };

    return (
        <EventNavigation>
            <BackButton
                onClick={handleRedirectToCompetitionPage}
                position='left'
            />

            <CarouselEventNavigation currentView={props.currentView} />
        </EventNavigation>
    );
});
